import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import LabShell from './LabShell';
import { statusMeta, fmtDate } from './orderConstants';
import { Card, CardContent } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { AlertTriangle, Loader2, FolderOpen, Clock } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LabOrdersList() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrders = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/orders`);
      setOrders(data);
    } catch (e) {
      toast.error('Erreur de chargement des dossiers');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchOrders(); }, [fetchOrders]);

  return (
    <LabShell title="Dossiers attribués">
      {loading ? (
        <div className="flex justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : orders.length === 0 ? (
        <Card className="border-dashed"><CardContent className="py-12 text-center text-muted-foreground">
          <FolderOpen className="h-10 w-10 mx-auto mb-3 opacity-40" />
          <p>Aucun dossier attribué pour le moment.</p>
        </CardContent></Card>
      ) : (
        <div className="space-y-2" data-testid="lab-orders-list">
          {orders.map((o) => {
            const m = statusMeta(o.status);
            return (
              <Link key={o.id} to={`/lab/orders/${o.id}`} className="block">
                <Card className="border-border hover:border-primary/40 transition-colors" data-testid={`lab-order-row-${o.order_number}`}>
                  <CardContent className="py-3 flex items-center justify-between gap-3 flex-wrap">
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <span className="font-mono font-semibold text-sm">{o.order_number}</span>
                        {o.urgent && <AlertTriangle className="h-4 w-4 text-orange-500" />}
                      </div>
                      <p className="text-sm text-muted-foreground truncate">
                        {(o.patient_last_name || o.patient_ref)} case · {o.praticien_name} · {o.product_label}
                      </p>
                    </div>
                    <div className="flex items-center gap-3 shrink-0">
                      {o.fabricant_deadline && (
                        <span className="text-xs text-muted-foreground flex items-center gap-1">
                          <Clock className="h-3 w-3" />{fmtDate(o.fabricant_deadline)}
                        </span>
                      )}
                      <Badge variant="outline" className={m.cls}>{m.label}</Badge>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      )}
    </LabShell>
  );
}
